<template>
    <table class="mb-24">
        <tbody>
        <tr>
            <td><span class="font-semibold mr-4">{{ $t('invoice.title') }}: </span></td>
            <td>{{ title }}</td>
        </tr>
        <tr>
            <td><span class="font-semibold mr-4">{{ $t('invoice.price') }}: </span></td>
            <td><currency/> {{ price }}</td>
        </tr>
        <tr style="vertical-align: top;">
            <td><span class="font-semibold mr-4">{{ $t('invoice.to') }}: </span></td>
            <td>
                {{ billingDetails.name }}
                <br>
                {{ billingDetails.vat }}
                <br>
                {{ billingDetails.email }}
                <br>
                <br>
                {{ billingDetails.street }} {{ billingDetails.number }}
                <br>
                {{ billingDetails.postal_code }} {{ billingDetails.city }}, {{ billingDetails.country }}
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import BillingDetails from "../models/BillingDetails";
import Currency from './Currency';
import {useRepo} from 'pinia-orm';
import {mapState} from "pinia";
import {useAuthenticationStore} from "../state/modules/authentication";

export default {
    components: {
        Currency
    },
    props: {
        title: String,
        price: [String, Number]
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentCompanyId']),
        billingDetails() {
            return useRepo(BillingDetails).where('company_id', this.currentCompanyId).first();
        }
    }
}
</script>
